import React from 'react'

import FeatureWrap from './FeatureWrap'

import HubSpotForm from '../form/HubSpotForm'

const QuoteConfirmation = props => {
  return (
    <div style={{ marginBottom: '25px' }}>
      <div className="container">
        <div className="row">
          <h2 className="page-title">Get a Quote</h2>
        </div>
      </div>
      <div className="title-block-bar" style={{ backgroundColor: '#57ad65' }}>
        <div className="container">
          <p style={{ fontSize: '1.2rem' }}>
            Please fill out the form below, and we'll be happy to send you a quote for the
            requested options.
          </p>
        </div>
      </div>
      <div style={{ backgroundColor: '#57ad65' }}>
        <div className="container"></div>
      </div>
      <div className="container">
        <div>
          <div className="alert alert-success text-center">
            <h3>Your inquiry has been submitted</h3>
            <p>
              Thank you for contacting us, we will be in touch shortly regarding your
              request.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QuoteConfirmation
